"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/pl");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Alternatywny tekst:"
  },
  announcement_list_da155734: {
    message: "Lista og\u0142osze\u0144"
  },
  announcements_a4b8ed4a: {
    message: "Og\u0142oszenia"
  },
  assignments_1e02582c: {
    message: "Zadania"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Kolor t\u0142a; naciskaj do do\u0142u, aby wybra\u0107"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Anuluj przesy\u0142anie pliku"
  },
  cancel_image_upload_2c771950: {
    message: "Anuluj przesy\u0142anie obrazu"
  },
  cc_attribution_f6de631f: {
    message: "Przypisanie CC"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "Przypisanie CC, brak pochodnych"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "Niekomercyjne przypisanie CC"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "Niekomercyjne przypisanie CC, brak pochodnych"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "Niekomercyjne przypisanie CC, w r\xF3wnych cz\u0119\u015Bciach"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "Przypisanie CC, w r\xF3wnych cz\u0119\u015Bciach"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Sprawd\u017A, czy obraz ma charakter dekoracyjny"
  },
  choose_usage_rights_33683854: {
    message: "Wybierz prawa u\u017Cytkowania..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Kliknij dowolny plik, aby umie\u015Bci\u0107 \u0142\u0105cze umo\u017Cliwiaj\u0105ce jego pobranie."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Kliknij dowolny obraz, aby osadzi\u0107 go na stronie."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Kliknij dowoln\u0105 stron\u0119, aby umie\u015Bci\u0107 do niej \u0142\u0105cze."
  },
  click_to_embed_image_33107dd8: {
    message: "Kliknij, aby osadzi\u0107 obraz"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Kliknij, aby osadzi\u0107 obraz { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Kliknij, aby wstawi\u0107 \u0142\u0105cze do edytora."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Kliknij, aby wstawi\u0107 \u0142\u0105cze do tego elementu."
  },
  close_flickr_form_b32e600a: {
    message: "Zamknij formularz Flickr"
  },
  collaborations_5c56c15f: {
    message: "Projekty wsp\xF3\u0142pracy"
  },
  copyright_holder_66ee111: {
    message: "W\u0142a\u015Bciciel praw autorskich:"
  },
  course_navigation_dd035109: {
    message: "Nawigowanie po kursie"
  },
  creative_commons_license_725584ae: {
    message: "Licencja Creative Commons:"
  },
  decorative_image_fde98579: {
    message: "Obraz dekoracyjny"
  },
  discussions_a5f96392: {
    message: "Dyskusje"
  },
  discussions_index_6c36ced: {
    message: "Spis dyskusji"
  },
  embed_image_1080badc: {
    message: "Osad\u017A obraz"
  },
  enter_search_terms_e397b1f0: {
    message: "wprowad\u017A szukane terminy"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Wpisz alternatywny tekst dla tego obrazu"
  },
  file_upload_form_4aaad554: {
    message: "Formularz przesy\u0142ania plik\xF3w"
  },
  files_c300e900: {
    message: "Pliki"
  },
  files_index_af7c662b: {
    message: "Wykaz plik\xF3w"
  },
  folder_705fd2d7: {
    message: "Folder"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Rozmiar czcionki; naciskaj do do\u0142u, aby wybra\u0107"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Formatowanie; naciskaj do do\u0142u, aby wybra\u0107"
  },
  grades_a61eba0a: {
    message: "Oceny"
  },
  group_navigation_99f191a: {
    message: "Nawigowanie po grupach"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "Mam uprawnienie do korzystania z tego pliku."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Posiadam prawa autorskie"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Je\u015Bli nie wybierzesz teraz praw do korzystania, po przes\u0142aniu plik nie zostanie opublikowany."
  },
  image_upload_form_7b74079a: {
    message: "Formularz przesy\u0142ania obraz\xF3w"
  },
  images_7ce26570: {
    message: "Obrazy"
  },
  insert_equella_links_49a8dacd: {
    message: "Wstaw \u0142\u0105cza Equella"
  },
  insert_link_6dc23cae: {
    message: "Umie\u015B\u0107 \u0141\u0105cze"
  },
  insert_math_equation_57c6e767: {
    message: "Wpisz r\xF3wnanie matematyczne"
  },
  link_7262adec: {
    message: "\u0141\u0105cze"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Po\u0142\u0105cz z now\u0105 stron\u0105"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Po\u0142\u0105cz z inn\u0105 zawarto\u015Bci\u0105 z kursu."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Po\u0142\u0105cz z inn\u0105 zawarto\u015Bci\u0105 grupy."
  },
  link_to_url_52dd935c: {
    message: "\u0141\u0105cze do adresu URL"
  },
  links_14b70841: {
    message: "\u0141\u0105cza"
  },
  load_more_results_460f49a9: {
    message: "Wczytaj wi\u0119cej wynik\xF3w"
  },
  loading_25990131: {
    message: "Trwa \u0142adowanie..."
  },
  loading_failed_b3524381: {
    message: "Niepowodzenie wczytywania..."
  },
  loading_folders_8d4d5d5a: {
    message: "Wczytywanie folder\xF3w..."
  },
  modules_c4325335: {
    message: "Modu\u0142y"
  },
  no_results_940393cf: {
    message: "Brak wynik\xF3w."
  },
  pages_e5414c2c: {
    message: "Strony"
  },
  people_b4ebb13c: {
    message: "U\u017Cytkownicy"
  },
  quizzes_7e598f57: {
    message: "Testy"
  },
  record_upload_media_5fdce166: {
    message: "Utw\xF3rz/prze\u015Blij pliki multimedialne"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Obszar Rich Text. Wci\u015Bnij ALT+F8 po pomoc"
  },
  search_280d00bd: {
    message: "Wyszukaj"
  },
  search_flickr_6884b518: {
    message: "Przeszukaj Flickr"
  },
  select_a_file_53ba40ac: {
    message: "Wybierz plik"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "Wybierz folder, aby przes\u0142a\u0107 do niego plik"
  },
  syllabus_f191f65b: {
    message: "Program"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Kolor tekstu; naciskaj do do\u0142u, aby wybra\u0107"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Materia\u0142 znajduje si\u0119 w domenie publicznej"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Materia\u0142 jest obj\u0119ty licencj\u0105 Creative Commons"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "Materia\u0142 podlega wyj\u0105tkowi dozwolonego u\u017Cytku"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Ta przesy\u0142ka przekracza przydzia\u0142 magazynowania plik\xF3w. Skontaktuj si\u0119 z administratorem systemu."
  },
  upload_8b403d05: {
    message: "Pobierz"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Przeka\u017C nowy plik"
  },
  upload_a_new_image_890df275: {
    message: "Przeka\u017C nowy obraz"
  },
  usage_right_ff96f3e2: {
    message: "Prawo u\u017Cytkowania:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Jak chcesz nazwa\u0107 now\u0105 stron\u0119?"
  },
  wiki_home_9cd54d0: {
    message: "Wiki \u2014 Strona g\u0142\xF3wna"
  }
};

_formatMessage.default.addLocale({
  pl: locale
});